import React from "react";
import { Typography } from "@mui/material";

export function Form_Header(props) {
    const {item, localFormState, setLocalFormState} = props;
    const {inputSize = "normal", key, weekKey = "week", yearKey = "year", valueKey} = item;

    const [str, setStr] = React.useState("");

    const updateLocalDate = () => {
        let val = localFormState[valueKey];

        if (val !== undefined && val !== null) {
            switch (val.length) {
                case 0: setStr("No Weeks Selected"); break;
                case 1: setStr(`Week ${val[0].week} of ${val[0].year}`); break;
                default: setStr(`${val.length} Weeks Selected`); break;
            }
        }
        else {
            setStr("No Week Selected")
        }

        // return;
        // if (val !== undefined && val !== null){
        //     let [selectedYear, selectedWeek] = val.split("-");
        //     setStr(`Week ${selectedWeek} of ${selectedYear}`);
        // }
        // else {
        //     setStr("No Week Selected")
        // }
    };

    React.useEffect(() => {
        updateLocalDate();
    }, [localFormState[valueKey]])

    return (<>
        <Typography style={{textAlign: "center"}} variant="h4" gutterBottom component="div">{str}</Typography>
    </>);
}